/**
 * Optum Manyata (All view): only this restaurant + SKUs are shown in the frontend.
 */
export const OPTUM_FC_ID = '67e4096be5d450001ad3d8bd';
export const OPTUM_RESTAURANT_ID = '685651876aedab001a2d3aa5';

/** Normalized itemname allow-list (lowercase). "paratha combo" also matches "plain paratha combo". */
const OPTUM_ALLOWED_SKU_PATTERNS = [
  'chapati combo',
  'paratha combo',
  'rice bath',
  'veg south indian thali',
];

export function isOptumFoodcourt(foodcourtid) {
  return String(foodcourtid || '').trim() === OPTUM_FC_ID;
}

export function isAllowedOptumSku(itemname) {
  const name = String(itemname || '').trim().toLowerCase();
  if (!name) return false;
  return OPTUM_ALLOWED_SKU_PATTERNS.some(
    (pattern) => name === pattern || name.includes(pattern)
  );
}

/** For Optum FC: keep only the allowlisted restaurant + SKUs; leave other foodcourts unchanged. */
export function filterOptumSkus(rows) {
  if (!rows || rows.length === 0) return rows || [];
  return rows.filter((row) => {
    if (!isOptumFoodcourt(row.foodcourtid)) return true;
    if (String(row.restaurant || '').trim() !== OPTUM_RESTAURANT_ID) return false;
    return isAllowedOptumSku(row.itemname);
  });
}
